import type { FaireProductEntity } from "../../entity_types/product";

export const p_8q2nsddjxb: FaireProductEntity = {
  token: "p_8q2nsddjxb",
  type: "product",
  name: "Outdoor Adventure Lightweight Slub Cardigan 5154ICD",
  brandToken: "b_ezr3agq73v",
  brandName: "Twentyten",
  imageUrl:
    "https://cdn.faire.com/fastly/1a856b77901d231756aad97949130694a60be3206b49e2306a413fd73c81eec0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd98ab4cd3e208178d3a1d41c1d3f1ef5b218547b650301dcdc8c2574a698f3a.jpeg",
    "https://cdn.faire.com/fastly/59f4689ba1958cf0931122831c01cd35cbd6c91ce9deb564e75b51a1e85123a6.jpeg",
    "https://cdn.faire.com/fastly/957ada1717e5355e8b15720125f217c3a58d855341757bda57ff3acef7303421.jpeg",
    "https://cdn.faire.com/fastly/f1e54381a2ffbfe4bc647659f316c90b8f04458a5c6cb01e40ed72399573d3ce.jpeg",
    "https://cdn.faire.com/fastly/929358eb8dd6dac86be182034becf22520fa04b7cb4b10e55ef68a04557b5efc.jpeg",
    "https://cdn.faire.com/fastly/953af4503fab07e646a546f9cb28627de2f37af8cea13e66f585d43a5d8136ae.png",
    "https://cdn.faire.com/fastly/cfa0ef20112ef51b8342f107b56bc1c85ab05189f4a07eea3a2d853bc6a70125.jpeg",
    "https://cdn.faire.com/fastly/445b109db3e42770721081c4faccc1ff1088d01fafc4ea69b1567a565b397f64.jpeg",
    "https://cdn.faire.com/fastly/c1b348180fd22bb129a9bd128b05d1c29e8cc8d4331653f8ccdc1c2fc2749f7c.jpeg",
    "https://cdn.faire.com/fastly/204f284ee363a27c888f3e5ecc6252e6cb12ff4d70086e3b6361a35769d9a2bd.jpeg",
    "https://cdn.faire.com/fastly/509cae2a4c67dd7c4f9a1464e8dc7bebe94b932fb5a5819eff70afbbb5917c39.jpeg",
    "https://cdn.faire.com/fastly/069cde59d199982380397a0989799eeec61207912e7949c1c87534abd5a31b97.png",
    "https://cdn.faire.com/fastly/c78e7ad7090113ebb2007589bc2e90e8411dbb8189a65a234a57fba7f5778376.png",
    "https://cdn.faire.com/fastly/5796500a7c31586e1ece9389c547c6030cb89f3602d8d485d601db1f7c06e5ed.jpeg",
    "https://cdn.faire.com/fastly/492cf4e63d97df283ae30c4037127e6e8f0fac451b7dac8148a13cdf960440ed.jpeg",
    "https://cdn.faire.com/fastly/408155239c858fc05d41830e9ce83a3f22e383da1b93823803b9c5d0f4c5f74c.jpeg",
    "https://cdn.faire.com/fastly/7e2c015b0bb14abc0aba9ee73da54def3648e48a9221d56977ae4e0293270ceb.jpeg",
    "https://cdn.faire.com/fastly/77dc1a760e73663356248d5c09ec336c68cae9e70b7dd04faeea9d2e2180a4b6.jpeg",
  ],
  priceDollars: 108.09,
  description:
    "LIGHT WEIGHT TEXTURED SLUB CARDIGAN\n-BUTTON DOWN CLOSURE\n-POCKET FRONT DETAIL",
  tags: [],
  msrpDollars: 216.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:58.250Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
